import { injectHubSpotScript } from '../helpers'
const Newsletter = () => {
	const newsletterModalTrigger = document.querySelector('.newsletter__open')
	const newsletterModalClose = document.querySelector('.newsletter__close')
	const newsletterModalBody = document.querySelector('.newsletter')
	const newsletterForm = document.querySelector('.newsletter__form__body')
	if(newsletterModalTrigger) {

		// modal open event on button click
		newsletterModalTrigger.addEventListener('click', (e) => {
			injectHubSpotScript(newsletterForm)

			// display modal window at the end
			newsletterModalBody.classList.toggle('newsletter--active')
			e.preventDefault()
		})

		// modal close event
		if (newsletterModalClose) {
			newsletterModalClose.addEventListener('click', (e) => {
				newsletterModalBody.classList.toggle('newsletter--active')
				e.preventDefault()
			})
		}
	}
}
export default Newsletter
